import React from "react";
import { useTheme } from "contexts";
import { FacebookIcon, InstagramIcon, MailIcon, WhatsAppIcon } from "assets";
import { HashLink as Link } from "react-router-hash-link";
import { navItems } from "constants";

export function Footer() {
  const { darkMode } = useTheme();

  return (
    <footer className="bg-background border-t border-border mt-24">
      <div className="container py-16">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="col-span-2">
            <div className="flex items-center gap-4">
              <img
                className="w-14 h-14 object-contain"
                src={
                  darkMode
                    ? "./dark_transparent_logo.png"
                    : "./light_mode_transparent_logo.png"
                }
                alt="SaleSpeed Logo"
              />
              <h2 className="text-xl font-bold text-main">Sale SpeedUp</h2>
            </div>

            <p className="mt-4 text-muted text-sm leading-relaxed max-w-md">
              The trusted digital infrastructure for the real estate and
              property industry. Build faster, sell smarter, and scale with
              confidence.
            </p>
          </div>

          <div>
            <h4 className="mb-5 text-lg font-semibold text-main">Company</h4>
            <ul className="space-y-3 text-sm">
              {navItems.map((item, index) => (
                <li key={index}>
                  <Link
                    to={`${item.to}`}
                    smooth
                    className="text-muted hover:text-accent transition duration-200"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-5 text-lg font-semibold text-main">Contact</h4>

            <div className="space-y-3">
              <div className="flex items-center gap-3 group">
                <MailIcon className="w-5 h-5 shrink-0" />
                <div>
                  <p className="text-xs text-muted">Email</p>
                  <a
                    href="https://mail.google.com/mail/?view=cm&fs=1&to=info@salespeedup.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm font-medium text-main hover:text-accent transition"
                  >
                    info@salespeedup.com
                  </a>
                </div>
              </div>

              {/* Phone */}
              <div className="flex items-center gap-3 group">
                <WhatsAppIcon className="w-5 h-5 shrink-0" />
                <div>
                  <p className="text-xs text-muted">Phone</p>

                  <div className="flex flex-col gap-1.">
                    <a
                      href="https://api.whatsapp.com/send?phone=923007886861&text=Hi%20I%20am%20interested%20in%20your%20services.%20Can%20you%20please%20share%20more%20details?"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm font-medium text-main hover:text-accent transition"
                    >
                      +923007886861
                    </a>
                    {/* <a
                    href="https://api.whatsapp.com/send?phone=923007886862&text=Hi%20I%20am%20interested%20in%20your%20services.%20Can%20you%20please%20share%20more%20details?"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm font-medium text-main hover:text-accent transition"
                  >
                    +923007886862
                  </a> */}
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-3 group">
                <FacebookIcon className="w-5 h-5 shrink-0" />
                <div>
                  <p className="text-xs text-muted">Facebook</p>
                  <a
                    href="https://www.facebook.com/salespeedup"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm font-medium text-main hover:text-accent transition"
                  >
                    Sale SpeedUp
                  </a>
                </div>
              </div>

              <div className="flex items-center gap-3 group">
                <InstagramIcon className="w-5 h-5 shrink-0" />
                <div>
                  <p className="text-xs text-muted">Instagram</p>
                  <a
                    href="https://www.instagram.com/salespeedup"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm font-medium text-main hover:text-accent transition"
                  >
                    salespeedup
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col md:flex-row justify-between items-center mt-16 pt-6 border-t border-border text-sm text-muted">
          <p>© 2026 Sale SpeedUp. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
